import "es6-promise/auto";
import Vue from "vue";
import Axios from "axios";
import Common from "../../components/common.js";

Vue.component("common", Common);

new Vue({
  el: "#uz-taejung-portfolio",
  data: function() {
    return {
      orderPages: [],
      isFetching: true,
      viewModel: {
        list: [],
        searchKeyword: "",
        listPerformance: []
      }
    };
  },
  computed: {
    isLoading: function() {
      return this.isFetching || this.viewModel.list.some(item => item.imageLoading);
    },
    performanceGroups() {
      const result = [];

      for (let i = 0; i < this.viewModel.listPerformance.length; i += 2) {
        result.push(this.viewModel.listPerformance.slice(i, i + 2));
      }

      return result;
    }
  },
  watch: {
    "viewModel.listPerformance": function() {
      this.scheduleOrderLayout();
    },
    performanceGroups: {
      handler() {
        this.$nextTick(() => {
          if (typeof AOS !== "undefined") {
            AOS.refreshHard();
          }
        });
      },
      deep: true
    }
  },
  mounted: function() {
    let vm = this;
    this._orderLayoutVersion = 0;
    window.addEventListener("resize", this.scheduleOrderLayout);
    if (document.fonts) {
      document.fonts.ready.then(() => this.scheduleOrderLayout());
      document.fonts.addEventListener("loadingdone", this.scheduleOrderLayout);
    }
    try {
      if (typeof AOS !== "undefined") {
        AOS.init({
          duration: 800,
          once: true,
          offset: 100
        });
        this.$nextTick(() => {
          AOS.refreshHard();
        });
      }

      vm.fnGetList();
    } catch (e) {
      console.log(e);
    }
  },
  beforeDestroy: function() {
    clearTimeout(this._orderLayoutTimer);
    this._orderLayoutVersion++;
    window.removeEventListener("resize", this.scheduleOrderLayout);
    if (document.fonts) document.fonts.removeEventListener("loadingdone", this.scheduleOrderLayout);
  },
  methods: {
    groupOrderRecords: function(records) {
      const groups = [];
      records.forEach(item => {
        const year = String(item.work_year || "");
        let group = groups[groups.length - 1];
        if (!group || group.year !== year) {
          group = { year: year, items: [] };
          groups.push(group);
        }
        group.items.push(item);
      });
      return groups;
    },
    scheduleOrderLayout: function() {
      clearTimeout(this._orderLayoutTimer);
      this._orderLayoutTimer = setTimeout(() => this.layoutOrders(), 100);
    },
    layoutOrders: function() {
      const version = ++this._orderLayoutVersion;
      const records = this.viewModel.listPerformance.slice().sort((a, b) => String(b.work_year || "").localeCompare(String(a.work_year || ""), undefined, { numeric: true }));
      this.orderPages = records.length ? [this.groupOrderRecords(records)] : [];
      this.$nextTick(() => {
        if (version !== this._orderLayoutVersion || this._isDestroyed || !records.length) return;
        const section = this.$el.querySelector(".orders-index");
        if (!section) return;
        // Measure real rows off screen at exactly the visible section's width.
        const probe = section.cloneNode(true);
        probe.removeAttribute("id");
        Object.assign(probe.style, {
          position: "fixed",
          left: "-100000px",
          top: "0",
          visibility: "hidden",
          width: section.getBoundingClientRect().width + "px",
          height: "auto",
          minHeight: "0",
          maxHeight: "none",
          pointerEvents: "none"
        });
        probe.setAttribute("aria-hidden", "true");
        probe.querySelectorAll("[data-aos]").forEach(el => {
          el.removeAttribute("data-aos");
          el.style.transform = "none";
          el.style.transition = "none";
        });
        const content = probe.querySelector(".orders-cont");
        const templates = Array.from(content.children).map(group => ({
          shell: group.cloneNode(true),
          rows: Array.from(group.querySelector(".bst").children)
        }));
        content.innerHTML = "";
        document.body.appendChild(probe);
        try {
          const limit = Math.max(600, Math.min(1080, window.innerHeight));
          const pages = [];
          let page = [];
          let recordIndex = 0;
          templates.forEach(template => {
            let groupNode;
            const newGroup = () => {
              groupNode = template.shell.cloneNode(true);
              groupNode.querySelector(".bst").innerHTML = "";
              content.appendChild(groupNode);
            };
            newGroup();
            template.rows.forEach(row => {
              groupNode.querySelector(".bst").appendChild(row);
              // Include the year group's trailing gap and section bottom padding.
              const bottom = groupNode.getBoundingClientRect().bottom - probe.getBoundingClientRect().top;
              const gap = parseFloat(window.getComputedStyle(groupNode).marginBottom) || 0;
              if (page.length && bottom + gap + 40 > limit) {
                pages.push(this.groupOrderRecords(page));
                page = [];
                content.innerHTML = "";
                newGroup();
                groupNode.querySelector(".bst").appendChild(row);
              }
              page.push(records[recordIndex++]);
            });
          });
          if (page.length) pages.push(this.groupOrderRecords(page));
          this.orderPages = pages;
        } finally {
          probe.remove();
        }
        this.$nextTick(() => {
          if (typeof AOS !== "undefined") AOS.refreshHard();
        });
      });
    },
    fnGetList: function() {
      let vm = this;
      vm.isFetching = true;
      console.log(vm.viewModel.searchKeyword);
      Axios.post("/taejung/board/list", { bbsId: "TJ_PORTFOLIO", searchKeyword: vm.viewModel.searchKeyword, paramPage: "PORTFOLIO" })
        .then(function(response) {
          let rs = response.data;
          vm.viewModel.list = (rs.list || []).map(item => Object.assign({}, item, {
            imageLoading: !!item.title_img
          }));
          vm.viewModel.listPerformance = rs.list;
          vm.isFetching = false;
        })
        .catch(function(ex) {
          vm.isFetching = false;
          console.log(ex);
        });
    }
  }
});



// WEBPACK FOOTER //
// ./src/uz/taejung/taejung-portfolio-controller.js